import { render, staticRenderFns } from "./book-gallery.vue?vue&type=template&id=08cb12b4&"
import script from "./book-gallery.vue?vue&type=script&lang=js&"
export * from "./book-gallery.vue?vue&type=script&lang=js&"
import style0 from "./book-gallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports